import { VSelect } from 'vuetify/lib'
import commonMixins from './commonMixins'
import { defaultFun } from '../utils'
import { SELECT_V1 } from '../type_name'
export default {
    name: SELECT_V1,
    mixins: [ commonMixins ],
    computed: {
        list_hash() {
            const { items, 'item-value':itemValue } = this.field
            return items.reduce((total, item) => {
                total[item[itemValue]] = item
                return total
            }, {})
        }
    },
    mounted() {
    
    },
    render(h) {
        const {
             // eslint-disable-next-line 
             slots,scopedSlots,
             key,
             _type = 'text',
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             multiple = false,
             ...params 
            } = this.field
        params.type = _type
        if (multiple && !Array.isArray(this.my_value[key])) {
            console.error(`多选情况下，${key}需要是数组`)
        }
        return h(VSelect, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                'no-data-text':params.noDataText || '暂无数据',
                'item-text': params['item-text'] || 'title',
                'item-value':params['item-value'] || 'key',
                value: this.my_value[key]
            },
            on: {
                blur,
                change:(data) => {
                    if (multiple) {
                        this.my_value[key].push(data)
                    } else {
                        this.my_value[key] = data
                    }
                 
                    change(data, this.list_hash && this.list_hash[data])
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup,
            }
        })
    }
}